import type { BattleCommand, CardId, PlayerId } from './types';

const PLAYER_IDS = new Set<PlayerId>(['player', 'bot']);

export type BattleCommandParseResult =
  | Readonly<{ ok: true; command: BattleCommand }>
  | Readonly<{ ok: false }>;

/** Runtime boundary for replay, network and untyped JavaScript callers. */
export function parseBattleCommand(value: unknown): BattleCommandParseResult {
  if (!value || typeof value !== 'object') return { ok: false };
  const candidate = value as Record<string, unknown>;
  if (candidate.type !== 'play-card'
    || !Number.isInteger(candidate.tick) || (candidate.tick as number) < 0
    || !Number.isInteger(candidate.sequence) || (candidate.sequence as number) < 1
    || typeof candidate.playerId !== 'string' || !PLAYER_IDS.has(candidate.playerId as PlayerId)
    || typeof candidate.cardId !== 'string' || candidate.cardId.length === 0
    || !candidate.position || typeof candidate.position !== 'object') return { ok: false };
  const position = candidate.position as Record<string, unknown>;
  if (typeof position.x !== 'number' || !Number.isFinite(position.x)
    || typeof position.y !== 'number' || !Number.isFinite(position.y)) return { ok: false };
  return {
    ok: true,
    command: {
      type: 'play-card',
      tick: candidate.tick as number,
      sequence: candidate.sequence as number,
      playerId: candidate.playerId as PlayerId,
      cardId: candidate.cardId as CardId,
      position: { x: position.x, y: position.y },
    },
  };
}
